export enum CulturalActivityType {
    CareerValuation = "CareerValuation",
    PeerCatchUp = "PeerCatchUp",
    CulturalIndex = "CulturalIndex",
    TeamAssessment = "TeamAssessment",
    ResilientBusinessAssessment = "ResilientBusinessAssessment",
    EmployeeEngagementAssessment = "EmployeeEngagementAssessment",
}
